import React, { Component } from "react";
import {
  WVUSForm,
  SelectControl,
  InputControl,
  TextAreaControl,
  validateRequired,
  validateEmail,
  validateMax,
  validateContainChars
} from "wvus-forms";

import { trim } from "validator";
import { postMessage } from "../../services/postMessage";
import AppAlertMessage from "../App/AppAlertMessage";
import appSettings from "../../settings/appSettings";

export class SponsorsEmailChildForm extends Component {
  constructor(props) {
    super(props);
    this.state = { alert: { status: null, message: "" }, processing: false };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.setAlert = this.setAlert.bind(this);
    this.setProcessing = this.setProcessing.bind(this);
    this.resetFields = this.resetFields.bind(this);
  }

  setAlert(status, message) {
    this.setState(() => {
      return { alert: { status, message } };
    });
  }

  setProcessing(flag) {
    this.setState(() => {
      return { processing: flag };
    });
  }

  resetFields() {
    const { resetField, getFormState } = this.props.formMethods;
    const formState = getFormState();
    Object.keys(formState.fields).map(function (fieldName) {
      resetField(fieldName);
    });
  }

  handleFormSubmit(e) {
    const { formMethods } = this.props;
    const { isFormValid, getFormState, updateFieldsState } = formMethods;
    // Prevent Default
    e.preventDefault();
    this.setProcessing(true);
    // Cancel If Not Valid
    if (!isFormValid()) {
      return false;
    }

    const formState = getFormState();
    const fieldStates = formState.fields;

    const fields = Object.keys(fieldStates).reduce((allFields, key) => {
      const fieldState = fieldStates[key];
      allFields[key] = fieldState.value;
      return allFields;
    }, {});

    postMessage(fields)
      .then((response) => {
        this.resetFields();
        this.setProcessing(false);
          this.setAlert("success", "Your message has been sent successfully!");
      })
      .catch((error) => {
        const errorData = error.response.data;
        switch (errorData.code) {
          case "rest_invalid_param":
            Object.keys(errorData.data.params).forEach(function (field) {
              let newFieldState = fieldStates[field];
              newFieldState.isValid = false;
              updateFieldsState(newFieldState);
            });
            this.setProcessing(false);
            this.setAlert("failure", "Invalid data provided, please try again or give us a call at 1.888.511.6548.");
            break;
          default:
            this.setProcessing(false);
            this.setAlert(
              "failure",
              "Oops, it looks like we ran into an error. Please try again or give us a call at 1.888.511.6548."
            );
            break;
        }
      });
  }

  render() {
    const validateChildID = (value) => {
      const childIDRegEx = /^[0-9]{6}-[0-9]{4}$/g;
      return {
        valid: childIDRegEx.test(trim(value)),
        message: "Please enter a valid Child ID. E.g. 123456-1234."
      };
    };
    const cnCountriesOptions = Object.keys(appSettings.countriesByISO).map((key) => {
      return { valueKey: key, valueText: appSettings.countriesByISO[key] };
    });

    cnCountriesOptions.unshift({
      valueKey: "",
      valueText: "▾ Select Country"
    });

    const { formMethods } = this.props;
    const submitDisabled = !formMethods.isFormValid() || this.state.processing;

    const { getFieldState } = formMethods;
    const MAX_MESSAGE_CHAR = 1500;
    const messageFieldLength =
      getFieldState("messageText").value && !!getFieldState("messageText").value.length
        ? getFieldState("messageText").value.length
        : 0;
    const messageCharacterCount = parseInt(MAX_MESSAGE_CHAR, 10) - parseInt(messageFieldLength, 10);

    return (
      <>
        <AppAlertMessage {...this.state.alert}></AppAlertMessage>

        <form id="unauthEmailForm" name="unauthEmailForm" onSubmit={(e) => e.preventDefault()}>
          <div className="unauthEmailFormFields">
            <div className="sponsorInfoFields">
              <h5>Sponsor Information</h5>
              <InputControl
                fieldId="sponsorFirstName"
                fieldName="sponsorFirstName"
                fieldTitle="First Name"
                fieldClasses="wvus-field-50"
                // fieldPlaceholder="First Name *"
                formMethods={formMethods}
                validators={[validateRequired, validateContainChars, validateMax(32)]}
              />

              <InputControl
                fieldId="sponsorLastName"
                fieldName="sponsorLastName"
                fieldTitle="Last Name"
                fieldClasses="wvus-field-50"
                // fieldPlaceholder="Last Name"
                formMethods={formMethods}
                validators={[validateRequired, validateContainChars, validateMax(32)]}
              />

              <InputControl
                fieldId="sponsorEmail"
                fieldName="sponsorEmail"
                fieldTitle="Email Address"
                fieldClasses="wvus-field-50"
                // fieldPlaceholder="Email Address"
                formMethods={formMethods}
                validators={[validateRequired, validateEmail, validateContainChars, validateMax(150)]}
              />

              <InputControl
                fieldId="sponsorAccountNumber"
                fieldName="sponsorAccountNumber"
                fieldTitle="Account Number"
                fieldClasses="wvus-field-50"
                // fieldPlaceholder="Account Number"
                formMethods={formMethods}
                validators={[validateRequired, validateContainChars, validateMax(11)]}
              />
            </div>
            <div className="childInfoFields">
              <h5>Child Information</h5>
              <SelectControl
                fieldId="childCountryCode"
                fieldName="childCountryCode"
                fieldOptions={cnCountriesOptions}
                fieldTitle="Sponsored Child's Country"
                fieldClasses="wvus-field-33"
                formMethods={formMethods}
                validators={[validateRequired]}
              />
              <InputControl
                fieldId="childName"
                fieldName="childName"
                fieldTitle="Sponsored Child's Name"
                fieldClasses="wvus-field-50"
                // fieldPlaceholder="Sponsored Child's Name"
                formMethods={formMethods}
                validators={[validateRequired, validateContainChars, validateMax(32)]}
              />
              <InputControl
                fieldId="childID"
                fieldName="childID"
                fieldTitle="Sponsored Child's ID"
                fieldClasses="wvus-field-50"
                fieldPlaceholder="XXXXXX-XXXX"
                formMethods={formMethods}
                validators={[validateRequired, validateContainChars, validateChildID]}
              />
            </div>
            <div className="messageField">
              <TextAreaControl
                fieldName="messageText"
                fieldRows={6}
                fieldTitle="Your Message"
                fieldClasses="wvus-field-newletter-message"
                labelClasses="message-label"
                inputClasses="message-input"
                formMethods={formMethods}
                validators={[validateRequired, validateMax(MAX_MESSAGE_CHAR)]}
                characterCount={messageCharacterCount}
              />
            </div>
          </div>
          <div className="unauthEmailFormSubmit">
            <button
              type="submit"
              className="btn btn-medium btn-primary"
              disabled={submitDisabled}
              onClick={this.handleFormSubmit}
            >
              {this.state.processing ? (
                <span>
                  <i className="fa fa-spinner fa-pulse fa-fw" />
                </span>
              ) : (
                ""
              )}
              Send Email
            </button>
          </div>
        </form>
      </>
    );
  }
}

export default SponsorsEmailChildForm;
